import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import Layout from '../../../components/Layout';
import { Col, Grid, Panel, Icon, Button } from 'rsuite';
import moment from 'moment';
import { Image } from 'react-bootstrap';
import ModalDetail from './ModalDetail';
import ModalMap from '../ModalMap';


class VisitDetails extends Component{
    constructor(props){
        super(props);

        this.getLocation = this.getLocation.bind(this);

        this.state = {
            startEmployee:"",
            startLocation:"",
            startDate:"",
            startLat:"",
            startLon:"",
            endEmployee:"",
            endLocation:"",
            endLat:"",
            endLon:"",
            endDate:"",
            deviceEmployee:"",
            time:"",
            evidenceList:[],
            startDateSearch:"",
            endDateSearch:"",
            backHome:false,
        }
    }

    async componentDidMount(){
        if(this.props.location.state !== undefined){
            if (this.props.location.state.origin) {

                this.setState({
                    backHome: true
                });
            } else {
                this.setState({
                    startDateSearch: this.props.location.state.startDate,
                    endDateSearch: this.props.location.state.endDate
                });
            }

        }

        var id = this.props.match.params.id;

        // El modal se maneja a mano (no vía el prop "modal" de fetchRequest)
        // porque éste lo cerraría apenas llega el JSON — mucho antes de que
        // las fotos de evidencia (que pueden ser muchas) realmente terminen
        // de descargar. Se precargan con Image() nativo antes de mostrar
        // nada y de cerrar el modal; cuando React las vuelva a pintar con
        // <Image> de react-bootstrap, el navegador ya las tiene en caché
        // (mismo URL), así que aparecen de inmediato.
        this.props.modal_loader.handleShow(this.props.t('modal.spin.loading'));

        var req = await this.props.fetchRequest({
            api:'check',
            method:'GET',
            url: 'visits/details/'+id,
            requireToken:true
        });

        if(req === undefined){
            this.props.modal_loader.handleClose();
            localStorage.clear();
            sessionStorage.clear();
            this.props.history.push('/login');
            return;
        }

        var evidenceList = req.visitEvidenceList.reverse();

        await Promise.all(evidenceList.map(item => new Promise(resolve => {
            var img = new window.Image();
            img.onload = resolve;
            img.onerror = resolve;
            img.src = item.compressedImageUrl && item.compressedImageUrl !== '' ?
                item.compressedImageUrl : 'data:image/jpeg;base64,'+item.imageBase64;
        })));

        this.setState({
            startEmployee: req.visitStartEmployee,
            startLocation: req.visitStartLocation,
            startLat: req.startLatitude !== null ? req.startLatitude : "",
            startLon: req.startLongitude !== null ? req.startLongitude : "",
            startDate: req.visitStartDate,
            endEmployee: req.visitEndEmployee,
            endLocation: req.visitEndLocation,
            endLat: req.endLatitude !== null ? req.endLatitude : "",
            endLon: req.endLongitude !== null ? req.endLongitude : "",
            endDate: req.visitEndDate,
            deviceEmployee: req.deviceEmployee,
            time: req.visitTime,
            evidenceList: evidenceList,
            startValidFace: req.startValidFace,
            endValidFace: req.endValidFace
        }, ()=>{
            this.props.modal_loader.handleClose();
        })
    }

    getLocation(lat, lng, name){
        this.modal_map.handleShow(lat, lng, name)
    }

    // Determina el estado visual (badge primary vs. muted) del ícono de
    // ubicación de cada tarjeta (Inicio/Fin) — hay 3 casos reales, no solo
    // 2: nombre de ubicación conocido (badge activo, no clickeable — ya se
    // ve el nombre en texto), solo coordenadas (badge activo y clickeable,
    // abre el mapa) o nada (badge apagado). Se preserva exactamente la
    // misma lógica que ya existía, solo se reskinea el resultado.
    locationBadgeClass(location, lat, lon){
        var hasName = location !== null && location !== " null" && location !== "";
        var hasCoords = lat !== "" && lon !== "";
        return (hasName || hasCoords) ? 'is-on' : 'is-off';
    }

    locationClickable(location, lat, lon){
        var hasName = location !== null && location !== " null" && location !== "";
        var hasCoords = lat !== "" && lon !== "";
        return !hasName && hasCoords;
    }

    renderVisitCard(title, employee, location, lat, lon, validFace, employeeLabel, date){
        const {t} = this.props;
        var clickable = this.locationClickable(location, lat, lon);

        return (
            <Panel className="panel-general visit-summary-card" shaded>
                <div className="visit-summary-title">{title}</div>
                <div className="visit-summary-row">
                    <span className="table-status-badge is-on"><Icon icon="user" /></span>
                    <span className="visit-summary-text">{employee}</span>
                </div>
                <div className="visit-summary-row">
                    <span
                        className={"table-status-badge "+this.locationBadgeClass(location, lat, lon)}
                        style={clickable ? {cursor:'pointer'} : null}
                        onClick={()=> clickable && this.getLocation(lat, lon, employee)}
                    >
                        <Icon icon="map-marker" />
                    </span>
                    <span className="visit-summary-text">
                        {location !== "" ? location : lat === "" ? t('screen.reports.visit.columns.no_location') : ""}
                    </span>
                </div>
                <div className="visit-summary-row">
                    <span className={"table-status-badge "+((employeeLabel !== null && validFace) ? 'is-on' : 'is-off')}>
                        <Icon icon="smile-o" />
                    </span>
                    <span className="visit-summary-text">{employeeLabel}</span>
                </div>
                <div className="visit-summary-date">{moment(date).format('DD/MM/YYYY - HH:mm')}</div>
            </Panel>
        );
    }

    render(){
        const {t} = this.props;

        return(
            <Layout {...this.props}>
                <h3 className="s-title-page">{t('screen.reports.visit.details.title')}</h3>
                <Grid fluid>
                    <Col xs={24} sm={10}>
                        {this.renderVisitCard(
                            t('screen.reports.visit.details.start'),
                            this.state.deviceEmployee,
                            this.state.startLocation,
                            this.state.startLat,
                            this.state.startLon,
                            this.state.startValidFace,
                            this.state.startEmployee,
                            this.state.startDate
                        )}
                    </Col>
                    <Col xs={24} sm={10} smOffset={4}>
                        {this.renderVisitCard(
                            t('screen.reports.visit.details.end'),
                            this.state.deviceEmployee,
                            this.state.endLocation,
                            this.state.endLat,
                            this.state.endLon,
                            this.state.endValidFace,
                            this.state.endEmployee,
                            this.state.endDate
                        )}
                    </Col>
                    <Col xs={24}>
                        <div className="visit-timeline">
                            <span className="visit-timeline-time">{this.state.time}</span>
                        </div>
                    </Col>
                    <Col xs={24} style={{marginTop:24}}>
                        <Panel className="panel-general" shaded>
                            <h4 className="s-picture-title">{t('screen.reports.visit.details.evidence')}</h4>
                            <Grid fluid>
                                {this.state.evidenceList.map((list, i)=>
                                    <Col xs={24} sm={12} md={4} key={i} style={{marginBottom:24}}>
                                        <div className="visit-photo-card" onClick={()=>this.modal_detail.handleShow(i, this.state.evidenceList)}>
                                            <div className="visit-photo-card-image">
                                                <Image
                                                    src={list.compressedImageUrl && list.compressedImageUrl !== ''? list.compressedImageUrl :  'data:image/jpeg;base64,'+list.imageBase64}
                                                    alt="imagen"
                                                />
                                            </div>
                                            <div className="visit-photo-card-caption">
                                                {list.description}
                                            </div>
                                        </div>
                                    </Col>
                                )}
                            </Grid>
                        </Panel>
                    </Col>
                    <Col xs={24} style={{textAlign:'center', marginTop:24}}>
                        <Button
                            className="toolbar-btn-outline"
                            onClick={(e)=> {
                                if (this.state.backHome) {
                                    this.props.history.push('/')
                                } else {
                                    this.props.history.push({
                                        pathname: '/reports/visit',
                                        state: {
                                            startDate: this.state.startDateSearch,
                                            endDate: this.state.endDateSearch
                                        }
                                    })
                                }

                            }}
                        >
                            {t('button.return')}
                        </Button>
                    </Col>
                </Grid>

                <ModalDetail {...this.props} onRef={ref => this.modal_detail = ref} />
                <ModalMap  {...this.props} onRef={ref => this.modal_map = ref} />
            </Layout>
        )
    }
}

export default withTranslation('translations')(VisitDetails);
